module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Weather/Cloud-fog-bc3d62363281b68c00802666ee5cca18.svg";